(() => {
  const init = (root) => {

  // Slenkamo bloko indikatorius: juodas segmentas pilkoje linijoje.
  const bindProgress = (scroller, bar) => {
    if (!scroller || !bar) return;
    const thumb = bar.querySelector('span');
    const update = () => {
      const max = scroller.scrollWidth - scroller.clientWidth;
      bar.hidden = max <= 1;
      if (max <= 1) return;
      const ratio = Math.min(1, scroller.clientWidth / scroller.scrollWidth);
      const width = Math.max(ratio * 100, 26);
      thumb.style.width = `${width}%`;
      thumb.style.transform = `translateX(${(scroller.scrollLeft / max) * (100 / width) * (100 - width)}%)`;
    };
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const items = (track) => Array.from(track.children);

  const scrollToItem = (track, index, smooth = true) => {
    const list = items(track);
    const item = list[Math.max(0, Math.min(index, list.length - 1))];
    if (!item) return;
    const left = item.offsetLeft - (track.clientWidth - item.clientWidth) / 2;
    track.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' });
  };

  const currentIndex = (track) => {
    const center = track.scrollLeft + track.clientWidth / 2;
    let best = 0;
    let dist = Infinity;
    items(track).forEach((item, i) => {
      const d = Math.abs(item.offsetLeft + item.clientWidth / 2 - center);
      if (d < dist) { dist = d; best = i; }
    });
    return best;
  };

  root.querySelectorAll('[data-neo-carousel]').forEach((track) => {
    const start = parseInt(track.dataset.neoStart || '0', 10);
    const init = () => {
      if (track.scrollWidth > track.clientWidth + 1 && start > 0) scrollToItem(track, start, false);
    };
    requestAnimationFrame(init);

    const wrap = track.parentElement;
    bindProgress(track, wrap.querySelector(':scope > [data-neo-progress]'));

    const prev = wrap.querySelector(':scope > [data-neo-prev]');
    const next = wrap.querySelector(':scope > [data-neo-next]');
    const dots = wrap.parentElement.querySelector(':scope > [data-neo-dots]');
    if (prev && next) {
      const step = (dir) => {
        if (track.scrollWidth <= track.clientWidth + 1) return;
        const first = items(track)[0];
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: dir * (first.clientWidth + gap), behavior: 'smooth' });
      };
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));
    }
    if (dots) {
      const renderDots = () => {
        const overflow = track.scrollWidth > track.clientWidth + 1;
        dots.hidden = !overflow;
        if (!overflow) return;
        if (dots.children.length !== items(track).length) {
          dots.innerHTML = items(track).map(() => '<span></span>').join('');
        }
        const active = currentIndex(track);
        Array.from(dots.children).forEach((d, i) => d.classList.toggle('is-active', i === active));
      };
      track.addEventListener('scroll', renderDots, { passive: true });
      window.addEventListener('resize', renderDots);
      renderDots();
    }
  });

  root.querySelectorAll('[data-neo-scroll]').forEach((scroller) => {
    const bar = scroller.parentElement.querySelector('[data-neo-progress-for]');
    bindProgress(scroller, bar);
  });

  // Skirtukai (produktai ir DUK).
  root.querySelectorAll('[data-neo-tabs]').forEach((group) => {
    const tabs = group.querySelectorAll('[data-neo-tab]');
    const panels = group.querySelectorAll('[data-neo-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
        panels.forEach((p) => { p.hidden = p.dataset.neoPanel !== tab.dataset.neoTab; });
        const panel = group.querySelector(`[data-neo-panel="${tab.dataset.neoTab}"]`);
        const track = panel?.querySelector('[data-neo-carousel]');
        if (track) { track.scrollLeft = 0; track.dispatchEvent(new Event('scroll')); }
      });
    });
  });

    // Kolekcija: linijų filtrai ir rūšiavimas.
    root.querySelectorAll('[data-neo-groups]').forEach((wrap) => {
      const chips = wrap.querySelectorAll('[data-neo-chip]');
      const groups = wrap.querySelectorAll('[data-neo-group]');
      chips.forEach((chip) => {
        chip.addEventListener('click', () => {
          const key = chip.dataset.neoChip;
          chips.forEach((c) => c.setAttribute('aria-selected', String(c === chip)));
          groups.forEach((g) => { g.hidden = key !== 'all' && g.dataset.neoGroup !== key; });
        });
      });
      const sort = wrap.querySelector('[data-neo-sort]');
      if (sort) {
        sort.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }
    });

    // Produktas: paketų pasirinkimas keičia prekę formoje, pavadinimą, nuotrauką ir adresą.
    root.querySelectorAll('[data-neo-pdp]').forEach((pdp) => {
      const variantInput = pdp.querySelector('[data-neo-pdp-variant]');
      const submit = pdp.querySelector('.product-form__submit');
      const title = pdp.querySelector('[data-neo-pdp-title]');
      const mainImg = pdp.querySelector('.neo-pdp__main-img');
      const badge = pdp.querySelector('[data-neo-pdp-badge]');
      const crumb = document.querySelector('[data-neo-pdp-crumb]');
      const eyebrow = pdp.querySelector('.neo-pdp__eyebrow');
      pdp.querySelectorAll('.neo-pkg input[type=radio]').forEach((radio) => {
        radio.addEventListener('change', () => {
          pdp.querySelectorAll('.neo-pkg').forEach((l) => l.classList.toggle('is-selected', l.contains(radio)));
          const d = radio.dataset;
          if (variantInput) { variantInput.value = radio.value; variantInput.disabled = d.available !== 'true'; }
          if (submit) submit.disabled = d.available !== 'true';
          if (title) title.textContent = d.title;
          if (crumb) crumb.textContent = `${eyebrow ? eyebrow.textContent + ' ' : ''}${d.title}`;
          if (mainImg && d.image) { mainImg.removeAttribute('srcset'); mainImg.src = d.image; }
          if (badge) { badge.hidden = !d.badge; badge.querySelector('span').textContent = d.badge || ''; }
          if (d.url) window.history.replaceState({}, '', d.url);
        });
      });
    });

    // Laikmatis iki išsiuntimo: „Užsakyk per X val. Y min. – gausi <data>“.
    root.querySelectorAll('[data-neo-countdown]').forEach((el) => {
      const cutoff = parseInt(el.dataset.cutoff || '14', 10);
      const text = el.querySelector('span');
      const months = ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio'];
      const isWorkday = (d) => d.getDay() !== 0 && d.getDay() !== 6;
      const nextWorkday = (d) => { const n = new Date(d); do { n.setDate(n.getDate() + 1); } while (!isWorkday(n)); return n; };
      const render = () => {
        const now = new Date();
        let ship = new Date(now);
        ship.setHours(cutoff, 0, 0, 0);
        if (!isWorkday(ship) || now >= ship) { ship = nextWorkday(now); ship.setHours(cutoff, 0, 0, 0); }
        const diff = Math.max(0, ship - now);
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const arrive = nextWorkday(ship);
        const tomorrow = new Date(now); tomorrow.setDate(now.getDate() + 1);
        const day = arrive.toDateString() === tomorrow.toDateString() ? 'rytoj, ' : '';
        const left = h >= 24 ? `${Math.floor(h / 24)} d. ${h % 24} val.` : `${h} val. ${m} min.`;
        text.textContent = `Užsakyk per ${left} – gausi ${day}${months[arrive.getMonth()]} ${arrive.getDate()} d.`;
      };
      render();
      setInterval(render, 30000);
    });
  };

  init(document);
  // Temos redaktorius perpiešia sekciją – iš naujo prijungiame elgseną.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

// Krepšelis: kiekis, šalinimas ir nuolaidos kodai be puslapio perkrovimo.
(() => {
  if (window.neoCartInit) return;
  window.neoCartInit = true;

  const rerender = async (cartEl) => {
    const id = cartEl.dataset.sectionId;
    const [sectionHtml, bubbleHtml] = await Promise.all([
      fetch(`${window.location.pathname}?section_id=${id}`).then((r) => r.text()),
      fetch(`${window.location.pathname}?section_id=cart-icon-bubble`).then((r) => (r.ok ? r.text() : '')).catch(() => ''),
    ]);
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const fresh = doc.querySelector('[data-neo-cart]');
    if (fresh) cartEl.innerHTML = fresh.innerHTML;
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && bubbleHtml) {
      const b = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
    // Laikmatis ir kt. elgsena perpieštame bloke.
    cartEl.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
  };

  const post = (url, body) =>
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });

  const busy = (cartEl, on) => cartEl.classList.toggle('is-busy', on);

  document.addEventListener('click', async (event) => {
    const cartEl = event.target.closest('[data-neo-cart]');
    if (!cartEl) return;

    const qtyBtn = event.target.closest('[data-neo-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('[data-neo-line]');
      busy(cartEl, true);
      try {
        const res = await post('/cart/change.js', { id: line.dataset.neoLine, quantity: Math.max(0, parseInt(qtyBtn.dataset.neoQty, 10)) });
        if (!res.ok) throw new Error((await res.json()).description || 'Nepavyko atnaujinti krepšelio');
        await rerender(cartEl);
      } catch (e) {
        alert(e.message);
      } finally {
        busy(cartEl, false);
      }
      return;
    }

    const removeCode = event.target.closest('[data-neo-remove-code]');
    if (removeCode) {
      busy(cartEl, true);
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());
        const left = (cart.discount_codes || []).map((d) => d.code).filter((c) => c !== removeCode.dataset.neoRemoveCode);
        await post('/cart/update.js', { discount: left.join(',') });
        await rerender(cartEl);
      } finally {
        busy(cartEl, false);
      }
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-neo-discount]');
    if (!form) return;
    event.preventDefault();
    const cartEl = form.closest('[data-neo-cart]');
    const code = form.querySelector('input[name=discount]').value.trim();
    const err = form.querySelector('[data-neo-discount-error]');
    if (!code) return;
    busy(cartEl, true);
    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const codes = (cart.discount_codes || []).map((d) => d.code).filter((c) => c.toLowerCase() !== code.toLowerCase());
      const res = await post('/cart/update.js', { discount: [...codes, code].join(',') });
      if (!res.ok) throw new Error();
      const updated = await res.json();
      const applied = (updated.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      await rerender(cartEl);
      if (!applied || !applied.applicable) {
        if (applied) await post('/cart/update.js', { discount: codes.join(',') });
        const e2 = cartEl.querySelector('[data-neo-discount-error]');
        if (e2) { e2.textContent = `Kodas „${code}“ negalioja arba šiam krepšeliui netinka.`; e2.hidden = false; }
        cartEl.querySelectorAll('.neo-cart__code.is-error:not([data-neo-discount-error])').forEach((n) => n.remove());
      }
    } catch (e) {
      if (err) { err.textContent = 'Nepavyko pritaikyti kodo. Pabandykite dar kartą.'; err.hidden = false; }
    } finally {
      busy(cartEl, false);
    }
  });

})();
